// src/pages/CourseTime/components/slides/layouts/ContentPointsWithImageSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layouts: content_2_points_with_1_image, content_3_points_with_1_image
const ContentPointsWithImageSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <S.SlideWithImage>
      {slide.Images && slide.Images.length > 0 && (
        <S.SlideImageContainer>
          <S.SlideImage
            src={typeof slide.Images[0] === 'string' ? slide.Images[0] : slide.Images[0].url || ''}
            alt={`Slide ${slide.SlideOrder} image`}
          />
        </S.SlideImageContainer>
      )}
      <S.SlidePointsContainer>
        {Array.isArray(slide.SlideContent) && slide.SlideContent.map((point, idx) => (
            <S.SlidePoint key={idx}>
              {typeof point === 'string' ? (
                  <S.PointText>{renderContent(`content_${idx}`, point)}</S.PointText>
              ) : (
                  <>
                    {point.PointTitle && <S.PointTitle>{renderContent(`content_${idx}_title`, point.PointTitle)}</S.PointTitle>}
                    {point.PointText  && <S.PointText>{renderContent(`content_${idx}_text`,  point.PointText)}</S.PointText>}
                  </>
              )}
            </S.SlidePoint>
        ))}
        {typeof slide.SlideContent === 'string' && (
            <S.SlidePoint>
              <S.PointText>{renderContent('content_0', slide.SlideContent)}</S.PointText>
            </S.SlidePoint>
        )}
      </S.SlidePointsContainer>
    </S.SlideWithImage>
  );
};

export default ContentPointsWithImageSlide;
